import type { FC } from 'react';
import React, { useMemo } from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon/base-new';

import { CopyLinkButton } from '@confluence/copy-content-link/entry-points/CopyLinkButton.ts';

import type { FollowingFeedSortByValue, PopularFeedTimeGranularityValue } from '../../../Feed.tsx';

import { ActionButtonWrapper } from './ActionButtonStyles.tsx';

type Props = {
	contentId: string;
	contentType: 'page' | 'blogpost';
	spaceKey?: string;
	source: string;
	popularFeedTimeGranularity?: PopularFeedTimeGranularityValue;
	followingFeedSortby?: FollowingFeedSortByValue;
	iconColor?: NewCoreIconProps['color'];
};

export const FeedCardCopyLinkAction: FC<Props> = ({
	contentId,
	contentType,
	spaceKey,
	source,
	popularFeedTimeGranularity,
	followingFeedSortby,
	iconColor,
}) => {
	const onClickAttributes = useMemo(() => {
		const result: { [key: string]: string } = {};

		if (popularFeedTimeGranularity) {
			result.popularFeedTimeGranularity = popularFeedTimeGranularity;
		}

		if (followingFeedSortby) {
			result.followingFeedSortby = followingFeedSortby;
		}

		if (Object.keys(result).length) {
			return result;
		}

		return undefined;
	}, [followingFeedSortby, popularFeedTimeGranularity]);

	return (
		<ActionButtonWrapper>
			<CopyLinkButton
				contentId={contentId}
				contentType={contentType}
				spaceKey={spaceKey ?? ''}
				source={source}
				onClickAttributes={onClickAttributes}
				buttonAppearance="subtle"
				tooltipPosition="top"
				iconColor={iconColor}
			/>
		</ActionButtonWrapper>
	);
};
